// Constantes de charte de l'onboarding.
//
// Volontairement PAS un createTheme : introduire un ThemeProvider repeindrait
// instantanément les 56 formulaires, qui comptent sur color="primary" = bleu MUI
// par défaut (112 des 122 occurrences de #1976d2 sont dans src/formulaires/).

export const VERT = '#2e7d32';
export const VERT_FONCE = '#1b5e20';
export const VERT_CLAIR = '#43a047';

export const GRADIENT_VERT = `linear-gradient(135deg, ${VERT} 0%, ${VERT_FONCE} 100%)`;
export const GRADIENT_VERT_HOVER = `linear-gradient(135deg, ${VERT_FONCE} 0%, #145218 100%)`;

export const OMBRE_BOUTON = '0 4px 14px rgba(46,125,50,0.3)';
export const OMBRE_BOUTON_HOVER = '0 6px 20px rgba(46,125,50,0.4)';

export const RAYON = 3;

// Grammaire « verre dépoli » déjà utilisée par la barre d'outils de VisasScreen.
export const FOND_VERRE = {
  backgroundColor: 'rgba(255,255,255,0.94)',
  backdropFilter: 'blur(8px)',
  boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
};
